function initialState() {
  return {
    campaigns: null,
    campaign: {
      id: "",
      enabled: false,
      campaignName: "",
      impressionLimit: null,
      startDate: "",
      endDate: "",
      schedule: {},
      adUrl: "",
      rateLimiting: {},
      providerRuleChains: [],
    },
    ruleChain: {},
    ruleChains: [],
    targets: null,
    targetDetail: null,
    advertisers: [],
    inventory: null,
    reports: null,
    advertisingDetails: null,
  }
}

let state = initialState()

export { initialState, state }
